import React from "react";
import { FiCheck } from "react-icons/fi";
import { motion } from "framer-motion";

const Whychoose = ({ heading, imageSrc, paragraph, listItems }) => {
  return (
    <section className="why-choose-section">

     

      <div className="why-choose-content">

        {/* IMAGE */}
        <motion.div
          className="why-choose-image"
          initial={{ opacity: 0, x: -60, scale: 0.95 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img src={imageSrc} alt={heading} />
        </motion.div>

        {/* TEXT */}
        <motion.div
          className="why-choose-text"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.18,
                delayChildren: 0.2,
              },
            },
          }}
        >
           {/* HEADING */}
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {heading}
      </motion.h2>
      
          {/* PARAGRAPH */}
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 25 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.6 },
              },
            }}
          >
            {paragraph}
          </motion.p>

          {/* LIST */}
          <ul>
            {listItems.map((item, index) => (
              <motion.li
                key={index}
                variants={{
                  hidden: { opacity: 0, x: 25 },
                  visible: {
                    opacity: 1,
                    x: 0,
                    transition: { duration: 0.5 },
                  },
                }}
              >
                {/* CHECK ICON */}
                <motion.span
                  className="why-choose-check"
                  initial={{ scale: 0, rotate: -90 }}
                  whileInView={{ scale: 1, rotate: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 260,
                    delay: index * 0.12,
                  }}
                  viewport={{ once: true }}
                >
                  <FiCheck />
                </motion.span>
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

      </div>
    </section>
  );
};

export default Whychoose;
